import { WithCommonProps } from '@types';
import { getDividerStylesAsClassName } from './divider-styles';

export enum DividerVariant {
  GRAY = 'gray',
  WHITE = 'white',
}

export type IDividerProps = WithCommonProps<{
  variant?: DividerVariant;
}>;

export const Divider = ({
  variant = DividerVariant.GRAY,
  ...rest
}: IDividerProps): JSX.Element => {
  return <hr className={getDividerStylesAsClassName(variant)} {...rest} />;
};
